<script>
export default {
    name: 'IconPrint',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-print"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M48 8v10h8v29h-8v9H16v-9H8V18h8V8h32zm-6 34H22v8h20v-8zM24 27h-6v6h6v-6zm18-13H22v4h20v-4z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
